// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.9/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.9/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tooltip[data-v-5bc2bafc]{background-color:#fff;border-radius:4px;color:#000;opacity:1}.dotted-tooltip__activator[data-v-5bc2bafc]{border-bottom:1px dotted}.dotted-tooltip__activator.active[data-v-5bc2bafc]{color:#1e88e5;border-color:#1e88e5}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
